import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { templates } from 'src/app/shared/contract-template';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BehaviorSubjectConfirmationService } from 'src/app/shared/services/behavior-subject-confirmation.service';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import * as html2pdf from 'html2pdf.js';
import { Validators } from 'src/app/shared/validators';
import { SaveContractDataService } from '../../../services/save-contract-data.service';
import { saveAs } from 'file-saver-es';
import { asBlob } from 'html-docx-js-typescript';
import { FetchBasicUserInfoService } from '../../../services/fetch-basic-user-info.service';
import { ContractStatusNotifierService } from '../../../services/contractStatusNotifier.service';
import { BankAccountAddedNotifierService } from '../BankAccountAddedNotifier.service';
import { ContractFormStatusService } from 'src/app/shared/services/contract-form-status.service';

@Component({
  selector: 'app-business-contract-data',
  templateUrl: './business-contract-data.component.html',
  styleUrls: ['./business-contract-data.component.scss'],
})
export class BusinessContractDataComponent implements OnInit {
  fvRegisteredBusiness = new FormValidatorService();
  fvUnRegisteredBusiness = new FormValidatorService();
  registeredBusinessForm!: FormGroup;
  unRegisteredBusinessForm!: FormGroup;
  hasBusinessRegistered = true;
  bankAccounts:string;
  header =
    "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
    "xmlns='http://www.w3.org/TR/REC-html40'>" +
    "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
  footer = '</body></html>';
  checkBankAccountIfAvailable: boolean = true;
  contractBussinessOwner: string = '';
  contractBodySeller: string = '';
  contractStatus:string;
  allDisabled:boolean;
  contractBussinessOwnerTemplate: string = templates.contractBussinessOwner;
  contractBodySellerTemplate: string = templates.contractBodySeller;
  busniessCreatedAt;
  userMail:string;
  userPhone:string;
  businessName:string;
  pattern = "^[0-9-]*";
  isEdit=true;
  constructor(
    private auth: AuthService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private saveContractData: SaveContractDataService,
    private behaviourSubjectContract: BehaviorSubjectConfirmationService,
    private getUserInfo: FetchBasicUserInfoService,
    private contractServNotifier: ContractStatusNotifierService,
    private bankAccoundAddedNotifier: BankAccountAddedNotifierService,
    private contractFormStatusService: ContractFormStatusService
  ) {}

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.fvRegisteredBusiness.validationMessages = {
        exactRegisterName: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Exact registered business name',
            fieldAr: 'الاسم التجاري المسجل بالضبط',
          }),
        },
        commericalRegisterNumber: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Commercial register number',
            fieldAr: 'رقم السجل التجاري',
          }),
        },
        registeredBusinessAddress: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Registered business address',
            fieldAr: 'عنوان العمل المسجل',
          }),
        },
        taxRegistrationNumber: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Tax Registration Number',
            fieldAr: 'رقم التسجيل الضريبي',
          }),
          pattern: this.translate.instant('FormValidation.Pattern', {
            field: 'Tax Registration Number',
            fieldAr: 'رقم التسجيل الضريبي',
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Tax Registration Number',
            fieldAr: 'رقم التسجيل الضريبي',
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'Tax Registration Number',
            fieldAr: 'رقم التسجيل الضريبي',
          }),
        },
        businessOwnerFullName: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Business owner full name',
            fieldAr: 'الاسم الكامل لصاحب العمل',
          }),
        },
        businessOwnerNationalID: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Business owner national id number',
            fieldAr: 'الرقم القومي لصاحب العمل',
          }),
        },
      };
      this.fvUnRegisteredBusiness.validationMessages = {
        fullName: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Full name',
            fieldAr: 'الاسم بالكامل',
          }),
        },
        businessName: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Business Name',
            fieldAr: 'الاسم التجاري',
          }),
        },
        nationalID: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'National id number',
            fieldAr: 'الرقم القومي',
          }),
        },
      };
    });
  }
  get isSubmitted() {
    return (
      (this.contractStatus == 'submitted' && this.isEdit==false) || this.contractStatus == 'confirmed'
    );
  }
  async ngOnInit() {
    this.bankAccoundAddedNotifier.getStatusNotification().subscribe(userBankResult=>{
      const newUpdatedBankObject={
        holder_name:userBankResult.holder_name,
        account_number:userBankResult.account_number,
        Branch:{
          arabic_branch_name:userBankResult.arabic_branch_name,
          Bank:{
            arabic_bank_name:userBankResult.arabic_bank_name,
          }
        }
      };
      this.perparingTheBankTable([newUpdatedBankObject]);
    });

    const res = await this.getUserInfo.make();
    this.userMail = res.email;
    this.userPhone = res.phone;
    const localStorageBusiness = await this.auth.getBusiness();
    this.businessName = localStorageBusiness.name;
    this.contractStatus = localStorageBusiness.contractStatus;
    this.registeredBusinessForm = this.fvRegisteredBusiness.createForm([
      {
        fieldName: 'exactRegisterName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'commericalRegisterNumber',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'registeredBusinessAddress',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'taxRegistrationNumber',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: 'Tax Registration Number is Required',
          },
          {
            validatorFn: Validators.pattern(this.pattern),
            message: 'Tax Registration Number must be numbers',
          },
          {
            validatorFn: Validators.maxLength(11),
            message: 'Tax Registration Number should be 9 numbers',
          },
          {
            validatorFn: Validators.minLength(11),
            message: 'Tax Registration Number should be 9 numbers',
          }
        ],
      },
      {
        fieldName: 'businessOwnerFullName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'businessOwnerNationalID',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
    ]);

    this.unRegisteredBusinessForm = this.fvUnRegisteredBusiness.createForm([
      {
        fieldName: 'fullName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'businessName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'nationalID',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
    ]);
  }
  async initForms(oldContractData) {
    await this.ngOnInit();
    moment.locale('ar');
    this.busniessCreatedAt = moment((await this.auth.getBusiness()).createdAt).format(
      'L'
    );
    this.contractStatus = oldContractData.Business.contractStatus;
    if (oldContractData.BusinessId) {
      this.perparingTheBankTable(oldContractData.Business.BankAccounts);
      this.hasBusinessRegistered = oldContractData.hasRegisteredBusiness;
      if (this.hasBusinessRegistered) {
        this.registeredBusinessForm.controls[
          'commericalRegisterNumber'
        ].setValue(oldContractData.commericalRegisterNumber);
        this.registeredBusinessForm.controls['exactRegisterName'].setValue(
          oldContractData.exactRegisterName
        );
        this.registeredBusinessForm.controls[
          'registeredBusinessAddress'
        ].setValue(oldContractData.registeredBusinessAddress);
        this.registeredBusinessForm.controls['businessOwnerFullName'].setValue(
          oldContractData.businessOwnerFullName
        );
        this.registeredBusinessForm.controls[
          'businessOwnerNationalID'
        ].setValue(oldContractData.businessOwnerNationalID);
        this.registeredBusinessForm.controls[
          'taxRegistrationNumber'
        ].setValue(oldContractData.taxRegistrationNumber);
        if (this.contractStatus == 'submitted' || this.contractStatus == 'confirmed') {
          this.contractFormStatusService.setContractFormStatus(1, true);
        }
        if (this.isSubmitted) {
          this.registeredBusinessForm.disable();
          this.contractFormStatusService.setContractFormStatus(0, false);
        }
      } else {
        this.unRegisteredBusinessForm.controls['fullName'].setValue(
          oldContractData.fullName || ''
        );
        this.unRegisteredBusinessForm.controls['nationalID'].setValue(
          oldContractData.nationalID || ''
        );
        this.unRegisteredBusinessForm.controls['businessName'].setValue(
          this.businessName || ''
        );
        if (this.contractStatus == 'submitted' || this.contractStatus == 'confirmed') {
          this.contractFormStatusService.setContractFormStatus(1, true);
        }
        if (this.isSubmitted) {
          this.unRegisteredBusinessForm.disable();
          this.contractFormStatusService.setContractFormStatus(0, false);
        }
      }
    } else {
      this.bankAccounts = '';
      this.registeredBusinessForm.controls['commericalRegisterNumber'].setValue(
        ''
      );
      this.registeredBusinessForm.controls['taxRegistrationNumber'].setValue(
        ''
      );
      this.registeredBusinessForm.controls['exactRegisterName'].setValue('');
      this.registeredBusinessForm.controls[
        'registeredBusinessAddress'
      ].setValue('');
      this.registeredBusinessForm.controls['businessOwnerFullName'].setValue(
        ''
      );
      this.registeredBusinessForm.controls['businessOwnerNationalID'].setValue(
        ''
      );

      this.unRegisteredBusinessForm.controls['fullName'].setValue('');
      this.unRegisteredBusinessForm.controls['nationalID'].setValue('');
      this.unRegisteredBusinessForm.controls['businessName'].setValue('');
    }

	  let num: string =
		  this.registeredBusinessForm.get('taxRegistrationNumber').value;
	  num = this.FormatTaxRegistrationNumber(num);
	  this.registeredBusinessForm.patchValue({ taxRegistrationNumber: num });
  }
  perparingTheBankTable(bankAccounts: [any]) {
    let body;
    let trs = [];
    for (const acc of bankAccounts) {
      let record = `<tr>
      <td style="border:1px solid black; border-collapse: collapse;padding-right:10px;">${acc.holder_name}</td>
      <td style="border:1px solid black; border-collapse: collapse;padding-right:10px;">${acc.Branch?.Bank.arabic_bank_name}</td>
      <td style="border:1px solid black; border-collapse: collapse;padding-right:10px;">${acc.Branch?.arabic_branch_name}</td>
      <td style="border:1px solid black; border-collapse: collapse;padding-right:10px;">${acc.account_number}</td>
      </tr>`;
      trs.push(record);
    }
    body = trs.join();
    this.bankAccounts = body;
  }
  async onSubmit() {
    this.checkBankAcounts();
    if (!this.checkBankAccountIfAvailable) return;
    let contractFormData: any;
	let num: string =
		this.registeredBusinessForm.get('taxRegistrationNumber').value;
    if (this.hasBusinessRegistered) {
      if (this.registeredBusinessForm.invalid) {
        this.fvRegisteredBusiness.forceShowErrors();
        return;
      }
	  num = this.UnFormatTaxRegistrationNumber(num);
	  this.registeredBusinessForm.patchValue({ taxRegistrationNumber: num });
	  contractFormData = {
		  ...this.registeredBusinessForm.value,
	  };
    } else {
      if (this.unRegisteredBusinessForm.invalid) {
        this.fvUnRegisteredBusiness.forceShowErrors();
        return;
      }
	  contractFormData = {
		  ...this.unRegisteredBusinessForm.value,
	  };
    }
    const formData = new FormData();

    const outputObject = { ...contractFormData };
    outputObject.confirm = false;
    for (const name of Object.keys(outputObject)) {
      if (outputObject[name]) formData.append(name, outputObject[name]);
    }
    this.saveContractData.setParams(formData);
    await this.saveContractData.make();
    await this.updateBusinessLocalStorage('submitted');
    this.isEdit=false;
    this.exportAs('pdf');
    this.showMessage(
      this.translate.instant('Sellers.Products.ContactDetailsSubmited')
    );
    this.contractFormStatusService.setContractFormStatus(1, true);
    this.contractFormStatusService.setContractFormStatus(0, false);

	num = this.FormatTaxRegistrationNumber(num);
	this.registeredBusinessForm.patchValue({ taxRegistrationNumber: num });
  }
  async updateBusinessLocalStorage(status: any) {
    this.contractServNotifier.pushStatusNotification(status);
    this.behaviourSubjectContract.renderData.next(true);
    const business = await this.auth.getBusiness()
    business.contractStatus = status;
    this.auth.setBusiness(business)
    this.contractStatus = status;
    if (this.hasBusinessRegistered) {
      this.registeredBusinessForm.disable();
    } else {
      this.unRegisteredBusinessForm.disable();
    }
  }
  checkBankAcounts() {
    if (!this.bankAccounts) {
      this.showMessage(
        this.translate.instant('Sellers.Products.AddBankAccount')
      );
      this.checkBankAccountIfAvailable = false;
    }
  }
  exportAs(type: string) {
    window.scrollTo(0, 0);
    var element = document.createElement('page');
    element.style.color = 'black';
    if (this.hasBusinessRegistered) {
      this.contractBussinessOwner = this.contractBussinessOwnerTemplate
        .replace('EMAIL_PLACEHOLDER', this.userMail)
        .replace('DATE_PLACEHOLDER', this.busniessCreatedAt)
        .replace('ACC_NAME_PLACEHOLDER', this.businessName)
        .replace('BANK_ACCOUNTS_PLACEHOLDERS', this.bankAccounts)
        .replace('PHONE_PLACEHOLDER', this.userPhone)
        .replace(
          'REGISTERED_BUSINESS_NAMAE',
          this.registeredBusinessForm.controls['exactRegisterName'].value
        )
        .replace(
          'COMMERICAL_NUMBER_PLACEHOLDER',
          this.registeredBusinessForm.controls['commericalRegisterNumber'].value
        )
        .replace(
          'BUSINESS_OWNER_NAME',
          this.registeredBusinessForm.controls['businessOwnerFullName'].value
        );
      element.innerHTML = this.contractBussinessOwner;
    } else {
      this.contractBodySeller = this.contractBodySellerTemplate
        .replace(
          'NAME_PLACEHOLDER',
          this.unRegisteredBusinessForm.controls['fullName'].value
        )
        .replace('DATE_PLACEHOLDER', this.busniessCreatedAt)
        .replace(
          'ID_PLACEHOLDER',
          this.unRegisteredBusinessForm.controls['nationalID'].value
        )
        .replace('BANK_ACCOUNTS_PLACEHOLDERS', this.bankAccounts)
        .replace('EMAIL_PLACEHOLDER', this.userMail)
        .replace('ACC_NAME_PLACEHOLDER', this.businessName)
        .replace('PHONE_PLACEHOLDER', this.userPhone);
      element.innerHTML = this.contractBodySeller;
    }
    type == 'pdf' ? this.toPDF(element) : this.toDoc(element.innerHTML);
  }

  async toDoc(element: any) {
    let content = [this.header, element, this.footer];
    const htmlString = content.join(' ');
    const data: any = await asBlob(htmlString, {});
    saveAs(data, 'contract.docx');
  }

  toPDF(element: any) {
    var opt = {
      margin: 5,
      filename: 'contract.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 1, dpi: 192, letterRendering: true },
      jsPDF: { format: 'a4' },
    };
    html2pdf().set(opt).from(element).save();
  }
  showMessage(message: string) {
    this.snackBar.open(message, null, {
      duration: 3000,
    });
  }

  convertRegisteredFormControls(name: string) {
    return this.registeredBusinessForm.get(name) as FormControl;
  }

  convertUnRegisteredFormControls(name: string) {
    return this.unRegisteredBusinessForm.get(name) as FormControl;
  }

  formatTaxRegistrationNumber() {
	  let num: string =
		  this.registeredBusinessForm.get('taxRegistrationNumber').value;
	  num = this.UnFormatTaxRegistrationNumber(num);
	  num = this.FormatTaxRegistrationNumber(num);
	  this.registeredBusinessForm.patchValue({ taxRegistrationNumber: num });
  }

  private FormatTaxRegistrationNumber(num: string): string {
	  return num.replace(/\B(?=(\d{3})+(?!\d))/g, "-");
  }

  private UnFormatTaxRegistrationNumber(num: string): string {
	  return num.replace(/-/g, '');
  }
}
